import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function PageHeader({ title, description, actions }: { title: string; description?: string; actions?: ReactNode }) {
  return <Stack className="page-header" direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} gap={1.25}>
    <Box sx={{ minWidth: 0 }}><Typography component="h1" variant="h1" sx={{ lineHeight: 1.15 }}>{title}</Typography>{description && <Typography color="text.secondary" sx={{ mt: .25, maxWidth: 900 }}>{description}</Typography>}</Box>
    {actions && <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center" sx={{ flexShrink: 0 }}>{actions}</Stack>}
  </Stack>;
}
